export function removeHtmlTags(innerHtml: string): string {
	const parsedHtml = new DOMParser().parseFromString(innerHtml, 'text/html');
	return parsedHtml.body.textContent ?? '';
}
